import { createSelector } from 'reselect';

const selectMySelection = state => state.mySelection;

export const selectMyCurrentSelection = createSelector(
  [selectMySelection],
  mySelection => mySelection?.mySelectionList
);
